/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Options, UnwrappedResult } from '../../.kubb/client'
import type { GetCourseDetailOptions, GetCourseDetailResponses } from '../../models/GetCourseDetail'
import { client, unwrapResult } from '../../.kubb/client'

/**
 * @summary Get Course
 * {@link /course/:course_id}
 */
export function getCourseDetail<ThrowOnError extends boolean = true>(options: Options<GetCourseDetailOptions, ThrowOnError>): Promise<UnwrappedResult<GetCourseDetailResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return unwrapResult(request({ method: 'GET', url: '/course/{course_id}', security: [{ type: 'oauth2' }], ...config, throwOnError: config.throwOnError ?? true }), config.throwOnError ?? true) as Promise<UnwrappedResult<GetCourseDetailResponses, ThrowOnError>>
}
